import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import FormMessage from '../../common/utility/FormMessage';
import { isEmpty } from '../../utils/obj-utils';
import FormBuilder from '../helpers/form-builder';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import * as verifyEmailFormActions from '../../../store/actions/verify-email-actions';
import * as signInActions from '../../../store/actions/sign-in-form-actions';

class VerifyEmailForm extends Component {
    constructor(props) {
        super(props);
        this.state = initialState.verifyEmailFormState;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.displayVerifyEmailForm = this.displayVerifyEmailForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.loadVerifyEmailFormData();
    }

    loadVerifyEmailFormData() {
        const { actions, verifyEmailFormData } = this.props;

        if (!isEmpty(verifyEmailFormData)) {
            return;
        }

        actions.loadSSOVerifyEmailFormData();
    }

    componentWillReceiveProps(nextProps) {
        const {
            isVerifyEmailSuccessful,
            loading
        } = nextProps;

        const { actions } = this.props;

        if (!loading && isVerifyEmailSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
            actions.signOutUser();

            return;
        }

        if (!loading && !isVerifyEmailSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
        }
    }

    componentWillUnmount() {
        this.resetForm();
    }

    resetForm() {
        const { actions } = this.props;
        this.setState(initialState.verifyEmailFormState);
        actions.resetVerifyEmailFormState();
    }

    handleSubmit(event) {
        event.preventDefault();
        const { verifyEmailFormData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(verifyEmailFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (!this.state.formHasErrors) {
            this.setState(formStateHelpers.updateProcessingState(true), this.submitVerifyEmailData);
        }
    }

    submitVerifyEmailData() {
        const { actions, verifyEmailFormData } = this.props;
        const { verificationCode } = this.state;
        const actionSuccessText = verifyEmailFormData.actionSuccessText || formMessageConstants.verifyEmailSuccessText;

        actions.handleUserVerifyEmail({ verificationCode, actionSuccessText });
    }

    displayForm() {
        const {
            isVerifyEmailSuccessful,
            verifyEmailMessages,
            verifyEmailFormData
        } = this.props;

        if (isEmpty(verifyEmailFormData)) {
            return null;
        }

        const { titleText, formText, buttonText } = verifyEmailFormData;

        return (<form onSubmit={this.handleSubmit}>
            <SSOFormHeader
                headerTitle={titleText}
                headerMessage={formText}
                messageOnNewRow={true}
            ></SSOFormHeader>
            <FormMessage
                isSuccessMessage={isVerifyEmailSuccessful}
                messages={verifyEmailMessages}></FormMessage>
            {this.displayVerifyEmailForm()}
            <SSOFormFooter
                onSubmit={this.handleSubmit}
                footerButtonText={buttonText || formMessageConstants.verifyEmail}>
            </SSOFormFooter>
        </form>);
    }

    displayVerifyEmailForm() {
        const { verifyEmailFormData, isReadOnly } = this.props;

        return FormBuilder({
            isReadOnly,
            formData: verifyEmailFormData,
            formReferences: this.formReferences,
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        return (
            <div className='modal__content form-container'>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    <br />
                    {this.displayForm()}
                </div >
            </div >
        );
    }
}

VerifyEmailForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    verifyEmailFormData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        verifyEmailFormData: state.verifyEmailForm.verifyEmailFormData,
        isVerifyEmailSuccessful: state.verifyEmailForm.isVerifyEmailSuccessful,
        verifyEmailMessages: state.verifyEmailForm.verifyEmailMessages,
        loading: state.apiStatus.apiCallsInProgress > 0
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSOVerifyEmailFormData: bindActionCreators(verifyEmailFormActions.loadSSOVerifyEmailFormData, dispatch),
            handleUserVerifyEmail: bindActionCreators(verifyEmailFormActions.handleUserVerifyEmail, dispatch),
            resetVerifyEmailFormState: bindActionCreators(verifyEmailFormActions.resetVerifyEmailFormState, dispatch),
            signOutUser: bindActionCreators(signInActions.signOutUser, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VerifyEmailForm);
